<template>
    <div>
        <div class="container-fluid d-flex flex-column" :class="{ 'iframe' : $route.query.iframe }">
            <main class="d-flex flex-column align-self-center">
                <router-view />
            </main>
        </div>
        <Footer />
        <NotificationToaster />
    </div>
</template>

<script>
import Footer from "./Footer";
import NotificationToaster from './NotificationToaster';

export default {
    name: 'home',
    components: {
        Footer,
        NotificationToaster
    }
}
</script>
